export default function Methodology() {
  const methods = [
    {
      icon: 'ri-gamepad-line',
      title: 'Juego como motor de aprendizaje',
      description: 'El juego es la herramienta principal para explorar, descubrir y aprender de forma natural y divertida.'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Vínculo afectivo',
      description: 'Creamos lazos de confianza y seguridad que permiten a cada niño sentirse querido y acompañado.'
    },
    {
      icon: 'ri-time-line',
      title: 'Rutinas saludables',
      description: 'Establecemos hábitos que aportan estructura, seguridad y bienestar en el día a día.'
    },
    {
      icon: 'ri-chat-smile-3-line',
      title: 'Estimulación del lenguaje',
      description: 'Fomentamos la comunicación verbal y no verbal a través de cuentos, canciones y conversaciones.'
    },
    {
      icon: 'ri-run-line',
      title: 'Psicomotricidad',
      description: 'Desarrollamos habilidades motoras gruesas y finas mediante actividades físicas adaptadas.'
    },
    {
      icon: 'ri-group-line',
      title: 'Desarrollo emocional y social',
      description: 'Acompañamos el reconocimiento de emociones y la interacción positiva con otros niños.'
    }
  ];

  return (
    <section id="methodology" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Nuestra Metodología</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Un enfoque integral que respeta el ritmo de cada niño y potencia su desarrollo en todas las áreas
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {methods.map((method, index) => (
            <div
              key={index}
              className="bg-[#F5F1E8] rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-[#87CEEB] rounded-full mb-6">
                <i className={`${method.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{method.title}</h3>
              <p className="text-gray-700 leading-relaxed">{method.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
